import { Component, OnInit, OnDestroy, HostListener, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { RouterLink, RouterLinkActive, Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';
import { ToggleService } from '../sidebar/toggle.service';
import { CustomizerSettingsService } from '../../customizer-settings/customizer-settings.service';
import { AuthService } from '../../services/user-service/AuthService';
import { Subscription } from 'rxjs';
import { NotificationDTO, NotificationService } from '../../customs/_services/notification.service';
import { ChatService, MessageDTO } from '../../customs/_services/chat.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    CommonModule, 
    MatMenuModule, 
    MatButtonModule, 
    RouterLink, 
    RouterLinkActive, 
    FormsModule, 
    NgClass,
    
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})

export class HeaderComponent implements OnInit, OnDestroy {

    isSidebarToggled = false;
    isToggled = false;
    user_name: string | null = null;
    role: string | null = null;
    notifications: NotificationDTO[] = [];
    messages: MessageDTO[] = [];

    totalUnreadMessagesValue: number = 0;
    private wsSubscription!: Subscription;
    constructor(
      private cdr: ChangeDetectorRef,
      private toggleService: ToggleService,
      public themeService: CustomizerSettingsService,
      private router: Router,
      private authService: AuthService,
      private chatService:ChatService,
      private notificationService: NotificationService,
          private snackBar: MatSnackBar
       // Injection de WebSocketService
    ) {
      // Observer le changement d'état de la sidebar
      this.toggleService.isSidebarToggled$.subscribe(isSidebarToggled => {
        this.isSidebarToggled = isSidebarToggled;
      });
  
      // Observer le changement de thème
      this.themeService.isToggled$.subscribe(isToggled => {
        this.isToggled = isToggled;
      });
  
      // Observer le changement d'utilisateur en direct
      this.authService.user$.subscribe(user => {
        this.user_name = user?.user_name || null;
        this.role = user?.role || null; 
      });
    }
  ngOnDestroy(): void {
    if (this.wsSubscription) {
      this.wsSubscription.unsubscribe();
    }
  }
  unreadSub!: Subscription;
totalUnreadMessages: number = 0;

  private subscriptions: Subscription[] = [];
  currentUserId: number | null = null;


ngOnInit(): void {
  const userIdStr = sessionStorage.getItem('user_id');
  const username = sessionStorage.getItem('user_username');

  if (userIdStr && username) {
    this.currentUserId = +userIdStr;
    console.log("ID de l'utilisateur connecté:", this.currentUserId);

    // 1. Se connecter au WebSocket
    this.chatService.connect(username)
      .then(() => {
        console.log('✅ WebSocket connecté');

        // 2. Après connexion, charger les messages non lus this.chatService.fetchUnreadMessages(this.currentUserId!);

        // 3. Charger les notifications depuis la BDD
        this.notificationService.loadNotificationsForUser(this.currentUserId!);
      })
      .catch(err => console.error('Erreur WebSocket Header:', err));

    // 4. Écouter les changements de messages non lus (indépendamment)
const unreadSub = this.chatService.unreadCounts$.subscribe(counts => {
  console.log('Unread counts received:', counts); // 🔍 Log les données reçues

  this.totalUnreadMessages = Object.values(counts).reduce((sum, count) => sum + count, 0);
  console.log('Total unread messages:', this.totalUnreadMessages); // 🔍 Log le total calculé

  this.cdr.detectChanges(); // Force la mise à jour de l'affichage
});
this.subscriptions.push(unreadSub);

    // 5. Écouter les notifications en temps réel via WebSocket
    const notifSub = this.notificationService.notification$.subscribe((notifications) => {
      console.log('Notifications reçues (BDD + Live) :', notifications);
      this.notifications = notifications;
    });
    this.subscriptions.push(notifSub);


  } else {
    console.error('❌ Aucun identifiant utilisateur trouvé dans sessionStorage');
  }
      const notifSub = this.chatService.notificationReceived$.subscribe((notif) => {
      console.log('📣 Nouvelle notification reçue:', notif);

      // ✅ Méthode 1 : Snackbar Angular Material
      this.snackBar.open(notif || 'Nouveau message reçu', 'Fermer', {
        duration: 3000,
        panelClass: ['notification-snackbar']
      });

      // ✅ Méthode 2 : simple alert (débogage uniquement)
      // alert(notif.content || 'Nouveau message reçu');
    });

    this.subscriptions.push(notifSub);
    
}

      clearNotifications(): void {
        this.notificationService.clearNotificationsBackend();
      }


      get unreadNotifications() {
        const userId = Number(sessionStorage.getItem('user_id')); // Récupérer l'ID de l'utilisateur connecté depuis le service d'authentification
        return this.notifications.filter(notif => !notif.read && notif.userId === userId);
      }

      markAsRead(notificationId: number, event: MouseEvent): void {
        event.stopPropagation();  // Empêcher l'événement de se propager
    
        this.notificationService.markAsRead(notificationId).subscribe(
          (response) => {
            // Mettre à jour l'état de la notification localement après l'appel API
            const notification = this.notifications.find((notif) => notif.id === notificationId);
            if (notification) {
              notification.read = true;
            }
          },
          (error) => {
            console.error('Erreur lors de la mise à jour de la notification', error);
          }
        );
      }

      markAllAsReadForUser(): void {
        const userId = Number(sessionStorage.getItem('user_id')); // Récupérer l'ID de l'utilisateur connecté depuis le service d'authentification
      
        this.notificationService.markAllAsReadForUser(userId).subscribe(
          (response) => {
            console.log(response.message); // Affiche "Toutes les notifications ont été marquées comme lues."
              this.unreadNotifications.forEach((notif) => {
              notif.read = true; // Marquer toutes comme lues localement
            });
          },
          (error) => {
            console.error('Erreur lors de la mise à jour des notifications', error);
          }
        );
      }
      
      
      
  toggleTheme() {
    this.themeService.toggleTheme();
  }

  toggleSidebarTheme() {
    this.themeService.toggleSidebarTheme();
  }

  toggleRightSidebarTheme() {
    this.themeService.toggleRightSidebarTheme();
  }

  toggleHideSidebarTheme() {
    this.themeService.toggleHideSidebarTheme();
  }

  toggleHeaderTheme() {
    this.themeService.toggleHeaderTheme();
  }

  toggleCardBorderTheme() {
    this.themeService.toggleCardBorderTheme();
  }

  toggleRTLEnabledTheme() {
    this.themeService.toggleRTLEnabledTheme();
  }

  // Déconnexion et redirection
  logout(): void {
    this.authService.logout();
    this.router.navigate(['/authentication/logout']);
  }

  // Toggle du menu latéral
  toggle() {
    this.toggleService.toggle();
  }

  isSticky: boolean = false;

  @HostListener('window:scroll', ['$event'])
  checkScroll() {
    this.isSticky = window.scrollY >= 50;
  }
}
